import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    display: "flex",
  },
  title: {
    fontSize: 20,
    fontWeight: 600,
    color: "#1B2A4A",
  },
  card: {
    padding: theme.spacing(3),
    borderRadius: 10,
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    backgroundColor: "#f7f7f7",
  },

  sectionTitle: {
    fontWeight: 600,
    fontSize: "0.85rem",
    color: "#7a7a7a",
    letterSpacing: "0.05em",
    marginBottom: theme.spacing(2),
  },

  fieldWrapper: {
    marginBottom: theme.spacing(2),
  },

  label: {
    fontSize: "0.7rem",
    color: "#7a7a7a",
    fontWeight: 600,
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    marginBottom: 4,
  },

  value: {
    fontSize: "0.9rem",
    color: "#222",
  },

  dividerRow: {
    padding: theme.spacing(1.5, 0),
  },

  slaRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(1.5, 0),
  },

  buttonWrapper: {
    marginTop: theme.spacing(2),
  },

  openButton: {
    textTransform: "none",
    borderRadius: 8,
  },
}));
